import React, { useEffect, useState } from 'react'

const usePointerOver = (ref: React.RefObject<HTMLElement | null>) => {
    const [isOver, setIsOver] = useState(false)

    useEffect(() => {
        const el = ref.current

        if (!el) return

        const checkIfInside = (e: PointerEvent) => {
            if (!el) return false

            const rect = el.getBoundingClientRect()

            const inside =
                e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom

            setIsOver(inside)
        }

        const handleDown = (e: PointerEvent) => {
            if (el.contains(e.target as Node)) {
                setIsOver(true)
            }
        }

        const handleMove = (e: PointerEvent) => {
            checkIfInside(e)
        }

        document.addEventListener('pointerdown', handleDown)
        document.addEventListener('pointermove', handleMove)

        return () => {
            document.removeEventListener('pointerdown', handleDown)
            document.removeEventListener('pointermove', handleMove)
        }
    }, [ref])

    return isOver
}

export default usePointerOver
